<template>
  <v-card
    class="border-radius-welcome"
    :style="{
      'background-color': getWebchat().campaign.color,
      color: invertColor(getWebchat().campaign.color),
      zoom: `1.${getWebchat().client.accessibility.fontSize}`,
    }"
  >
    <v-btn
      icon
      v-if="getWebchat().isLowRes"
      @click.native="minimizeWindow"
      class="right-arrow-back"
    >
      <v-icon
        :style="{
          color: invertColor(getWebchat().campaign.color),
        }"
        style="font-size: 28px !important"
        >mdi-chevron-left</v-icon
      >
    </v-btn>
    <div class="header-content">
      <div
        class="vtext-content"
        :style="{
          color: invertColor(getWebchat().campaign.color),
        }"
        v-html="getText"
      ></div>
    </div>
  </v-card>
</template>
<script>
import { invertColor } from "@/assets/utils";

export default {
  name: "welcome-message",
  data() {
    return {
      window: window,
    };
  },

  computed: {
    // Get Out-of-time / welcome message from store
    getText() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      let campaign = this.$store.state[index].campaign;
      let lang = this.$store.state[index].client.lang;
      let text = "";

      // If it timed out
      if (campaign.timeOut) {
        text = campaign.notavailablemessage[lang]
          ? campaign.notavailablemessage[lang]
          : campaign.notavailablemessage["en"];
      } else {
        // Checking campaign time
        if (campaign.onTime) {
          // checking if there are agents available
          if (campaign.available) {
            text = campaign.welcome[lang]
              ? campaign.welcome[lang]
              : campaign.welcome["en"];
          } else {
            text = campaign.notavailablemessage[lang]
              ? campaign.notavailablemessage[lang]
              : campaign.notavailablemessage["en"];
          }
        } else {
          // campaign out of time
          if (campaign.outoftime) {
            text = campaign.outoftime[lang]
              ? campaign.outoftime[lang]
              : campaign.outoftime["en"];
          }
        }
      }

      return text;
    },
  },

  methods: {
    invertColor,

    /**
     * @name MINIMIZE_WINDOW
     * @desc Broadcast event to entrypoint to minimize the chat
     */
    minimizeWindow() {
      window.parent.postMessage({ action: "MINIMIZE" }, "*");
    },

    getWebchat() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ];
    },
  },
};
</script>

<style scoped>
.border-radius-welcome {
  border-radius: 6px 6px 0 0 !important;
  width: 100%;
  z-index: 0;
}

.v-card__media__content {
  margin-right: -50px !important; /* maximum width of scrollbar */
  padding-right: 50px !important; /* maximum width of scrollbar */
  overflow-y: scroll !important;
}

.right-arrow-back {
  position: absolute !important;
  top: 2px;
  left: 0px;
  z-index: 99;
  transition: all 0.3s ease;
}

.right-arrow-back i {
  font-size: 39px !important;
}

.welcome-message-header {
  transition: all 0.3s ease-out;
  padding-bottom: 97px;
}

.welcome-message-header::after {
  content: "";
  background: linear-gradient(
    135deg,
    rgba(35, 146, 236, 0),
    rgba(0, 0, 0, 0.52)
  );
  background-blend-mode: overlay;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: -1;
}
</style>

<style>
/* scoped styles dont work with v-html */

.header-content {
  /* background-image: url('../assets/chat-background2.svg');
  height: 100%;
  background-size: cover; */
  padding: 32px 41px 0 40px;
}

.vtext-content {
  text-align: left;
  color: #fff;
}

.vtext-content > span,
.vtext-content > strong,
.vtext-content > i {
  position: relative;
  top: 10px;
  line-height: 28px;
}

.vtext-content img {
  position: relative !important;
  bottom: -3px !important;
}

.vtext-content > h1,
.vtext-content > h2,
.vtext-content > h3,
.vtext-content > h4,
.vtext-content > h5,
.vtext-content > h6 {
  font-weight: 200;
  position: relative;
  left: -2px;
}
</style>
